import type { UserRole } from '@doneverse/shared'

/**
 * Roles the `/messages` surface is gated to.
 *
 * Both message routes and the rail icon read this list rather than keeping
 * their own copies — the same drift risk `FEEDBACK_SURFACE_ROLES` exists for.
 *
 * Every role is here, admins included: group-chat membership is role-neutral,
 * so an admin can be picked as a member like anyone else and needs somewhere to
 * read the conversation. Reaching this surface is not the same as seeing
 * anything on it — access stays explicit membership, enforced in
 * `canAccessContact` with no admin bypass, so an admin who is in no chat and has
 * no DMs simply gets an empty list.
 */
export const MESSAGING_SURFACE_ROLES: UserRole[] = [
  'founder',
  'doer',
  'doing_team',
  'intake_team',
  'escalation_officer',
  'admin',
]
